<app-store-navigation></app-store-navigation>
@if (store) {
  <div>
    <div class="d-inline-block align-top col-md-6 ps-0 pe-4">
      @if (dataService.userHasAuthority(Authority.AUTH_SEE_TRADING_TIMES)) {
        <div class="trading-times">
          <app-default-working-times
            class="table"
            [storeId]="store.slug"
            [defaultWorkingTimes]="store.defaultWorkingTimes"
            (getStoreDetailsEvent)="getStoreDetails()">
          </app-default-working-times>
        </div>
      }
      @if (dataService.userHasAuthority(Authority.AUTH_SEE_TRADING_TIMES)) {
        <div class="trading-times">
          <app-specific-working-times
            [storeId]="store.slug"
            [workingTimes]="store.specialWorkingTimes"
            (getStoreDetailsEvent)="getStoreDetails()">
          </app-specific-working-times>
        </div>
      }
      @if (dataService.userHasAuthority(Authority.AUTH_SEE_STORE_CLOSED)) {
        <div class="store-closed">
          <app-store-closure
            [storeId]="store.slug"
            [storeClosures]="store.storeClosures"
            (getStoreDetailsEvent)="getStoreDetails()">
          </app-store-closure>
        </div>
      }
    </div>
    <div class="d-inline-block align-top col-md-6 pe-0">
      @if (dataService.userHasAuthority(Authority.AUTH_SEE_STORE_REQUIREMENTS)) {
        <div>
          <div class="requirements">
            <app-employee-requirements
              [storeId]="store.slug"
              [requirements]="store.employeeRequirements"
              (getStoreDetailsEvent)="getStoreDetails()">
            </app-employee-requirements>
          </div>
        </div>
      }
      @if (dataService.userHasAuthority(Authority.AUTH_SEE_STORE_BANKING)) {
        <div class="banking-collection">
          <app-banking-settings
            [storeId]="store.slug"
            [bankingSettings]="store.bankingSettings"
            (getStoreDetailsEvent)="getStoreDetails()">
          </app-banking-settings>
        </div>
      }
    </div>
  </div>
}